module.exports = __webpack_public_path__ + "static/media/facebook.4f16e7d9.svg";